
export default {
  name: 'GbLink',
  props: {
    isUseNuxtLink: {
      type: Boolean,
      default: false
    },

    path: {
      type: String,
      required: true
    },

    isDisabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    nuxtLinkEvent() {
      return this.isDisabled ? 'disabled' : 'click'
    }
  }
}
